import { color } from '@utilitywarehouse/hearth-tokens';
import { Helmet } from 'react-helmet-async';

import './styles.scss';

interface ThemeColorProps {
  displayTop?: boolean;
  displayBottom?: boolean;
}

/**
 * set of tweaks to set the top-bar color on mobile devices.
 *
 * Android browsers and older Safari (< v26) will support the `theme-color` meta
 * tag and set it's `content` value as the relevant colour. However,
 * Safari >= 26 no longer supports this tag, instead seeking to automatically
 * set the colour based on adjacent content, prioritising fixed and sticky
 * elements, and falling back to background colour otherwise.
 *
 * https://nasedk.in/blog/ios26-safari-toolbar-colors/
 */

const ThemeColor = ({
  displayTop = false,
  displayBottom = false,
}: ThemeColorProps) => {
  return (
    <>
      <Helmet>
        <meta name="theme-color" content={color.light.background.brand} />
      </Helmet>

      {displayTop && <div className="topbar" aria-hidden="true"></div>}
      {displayBottom && <div className="bottombar" aria-hidden="true"></div>}
    </>
  );
};

export { ThemeColor };
